export { configClass };

import store from "../store";
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/analytics";
import { EventBus } from "../main";

class configClass {
  constructor() {
    this._config = null;
    this._vendorid = null;
    this._vendorkey = null;
    //
    this.loadConfig();
  }
  get config() {
    return this._config;
  }
  get vendorid() {
    return this._vendorid;
  }
  get vendorkey() {
    return this._vendorkey;
  }
  /**
   * @desc This method will load configuration.
   */
  loadConfig() {
    // prod - https://s3.amazonaws.com/conf.vlite.com/sdgr/prod-config.json - change facebook id
    // pre prod - https://s3.amazonaws.com/conf.vlite.com/sdgr/preprod-config.json

    // previously used - https://s3.amazonaws.com/conf.vlite.com/sdgr/v1/prod-config.json

    fetch(
      "https://sdg-preprod.firebaseio.com/config/jPa6e0sh.json?print=pretty",
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log("++++++++++++++config-details++++++++++++++", data);
        this._config = data;
        this._vendorid = data.vendor.vendorid;
        this._vendorkey = data.vendor.vendorkey = "yuZjz1lenAs0Fcsh"; // data.vendorkey
        //
        this.initAppTheme();
        //
        // EventBus.$emit("configLoaded");
        //
        store
          .dispatch("actLocate")
          .then((response) => {
            if (response.success) {
              let country = response.success;
              // console.log('============country===============', country);
              localStorage.setItem("country", JSON.stringify(country));
              // Commit Country
              store.commit("commitCountry", country);

              // EventBus.$emit('configLoaded')
            }
          })
          .catch((error) => {
            EventBus.$emit("signupError", error);
          });
        // //
        this.initAppCycle();
        this.fetchVendorInfo();
        //
        import(/* webpackChunkName: "userClass" */ /* webpackMode: "lazy" */ "./user-class").then(
          (user) => {
            this.user = new user.userClass();
          }
        );
      })
      .catch((error) => {
        console.log("[error]", error);
      });
  }
  /**
   * @desc This method acts as the main execution entry of the Entire App.
   */
  initAppCycle() {
    this.initAppFirebase();
    this.initFacebookSDK();
  }
  /**
   * @desc This method will fetch the App Configuration which includes the vendor and theme information which we need to store in the local storage which later will be used in different parts of the App.
   */
  initAppTheme() {
    // Setting AppConfig to local storage
    localStorage.setItem("AppConfig", JSON.stringify(this._config));
  }
  initAppFirebase() {
    // Check how many instance of firebase app has been registered. If already registered then apps.length will return >0. Then no need to register again.
    if (firebase.apps.length) return;

    let firebaseConfig = {
      apiKey: store.getters.FIRE_API_KEY,
      authDomain: store.getters.FIRE_AUTH_DOMAIN,
      databaseURL: store.getters.FIRE_DATABASE_URL,
      projectId: store.getters.FIRE_PROJECT_ID,
      storageBucket: store.getters.FIRE_STORAGE_BUCKET,
      messagingSenderId: store.getters.FIRE_MESSAGING_SENDER_ID,
      appId: store.getters.FCM_APP_ID,
    };
    firebase.initializeApp(firebaseConfig);

    // secondary Firebase - Only For GA
    let secondaryAppConfig = {
      apiKey: store.getters.FIRE_API_KEY2,
      authDomain: store.getters.FIRE_AUTH_DOMAIN2,
      databaseURL: store.getters.FIRE_DATABASE_URL2,
      projectId: store.getters.FIRE_PROJECT_ID2,
      storageBucket: store.getters.FIRE_STORAGE_BUCKET2,
      messagingSenderId: store.getters.FIRE_MESSAGING_SENDER_ID2,
      appId: store.getters.FCM_APP_ID2,
      measurementId: store.getters.FIRE_MEASUREMENT_ID2,
    };
    firebase.initializeApp(secondaryAppConfig, "secondary");
    store.commit("CommitUserStore");
    // this.initFCMNotifications();
    //
    EventBus.$emit("configLoaded");
  }
  initFCMNotifications() {
    // Retrieve Firebase Messaging object.
    let secondary = firebase.app("secondary");
    const messaging = secondary.messaging();
    // Add the public key generated from the console here.
    messaging.usePublicVapidKey(store.getters.FCM_CERTIFICATE_KEY2);

    if (navigator.serviceWorker) {
      navigator.serviceWorker.register("static/sw.js").then(
        (registration) => {
          messaging.useServiceWorker(registration);

          messaging
            .requestPermission()
            .then((res) => {
              messaging
                .getToken()
                .then((token) => {
                  // let url = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}`;

                  // console.log("[firebase url]", url);

                  // fetch(url, {
                  //   method: "POST",
                  //   headers: new Headers({
                  //     Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
                  //   })
                  // })
                  //   .then(() => {
                  //     console.log("[Vendor Topics Subscribed]");
                  //   })
                  //   .catch(error => {
                  //     console.log("[error]", error);
                  //   });
                  // const listenToSubscriberNotification = () => {
                  //   let subscriberUrl = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}_${store.getters.subscriberid}`;

                  //   console.log("[subscriberUrl]", subscriberUrl);

                  //   fetch(subscriberUrl, {
                  //     method: "POST",
                  //     headers: new Headers({
                  //       Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
                  //     })
                  //   })
                  //     .then(response => {
                  //       console.log("[Subscriber Topics Subscribed]");
                  //     })
                  //     .catch(error => {});
                  // };
                  // if (store.getters.subscriberid) {
                  //   listenToSubscriberNotification();
                  // }
                  localStorage.setItem("messageToken", token);
                  // notification
                  let notificationStatus = localStorage.getItem(
                    "notificationStatus"
                  );
                  // console.log("notificationStatus", notificationStatus);
                  if (
                    notificationStatus !== null &&
                    JSON.parse(notificationStatus)
                  ) {
                    store.dispatch("subscribeVendorAndSubscriberTopics");
                  } else {
                    if (notificationStatus === null) {
                      localStorage.setItem(
                        "notificationStatus",
                        JSON.stringify(true)
                      );
                      store.dispatch("subscribeVendorAndSubscriberTopics");
                    }
                  }
                })
                .catch((err) => {
                  console.log("[err]", err);
                });
            })
            .catch((err) => {
              console.log("[err]", err);
            });
          // firebase.notifications().onNotification(notification => {
          //   console("Inside notification", notification);
          // });
          messaging.onMessage(function(payload) {
            // console.log("[onMessage payload]", payload);
            //if (!store.getters.AppUser) return;

            let data = {
              ...payload,
              read: false,
              timestamp: new Date(),
              // timestamp: Math.floor(new Date().getTime() / 1000)
            };
            let fcm_notifications = localStorage.getItem("fcm_notifications");
            let notifications;
            if (fcm_notifications) {
              notifications = JSON.parse(fcm_notifications);
              notifications = [...notifications, data];
            } else {
              notifications = [data];
            }
            notifications = notifications.slice().reverse();

            localStorage.setItem(
              "fcm_notifications",
              JSON.stringify(notifications)
            );
            store.commit("commitFCMNotifications", true);

            if (Notification.permission === "granted") {
              let data = payload.data;
              var title = "SDG Notification";
              let body = "New message from SDG";
              let image = null;
              if (payload.data) {
                title = data.title;
                body = data.message;
                image = data.image_url;
              }
              var options = {
                body,
                image,
              };
              registration.showNotification(title, options);
            }
          });
        },
        (error) => {
          console.log("sw not reg", error);
        }
      );
    }
  }

  initFacebookSDK() {
    window.fbAsyncInit = function() {
      FB.init({
        // appId      : '1080582505471223',
        // appId: "1303739023127392", // test
        appId: "1024039847941842", // live
        // appId: "228226828540122", //myid
        cookie: true,
        xfbml: true,
        version: "v6.0",
      });
    };
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      // js.src ="//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v4.0&appId=511762009638895";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }

  fetchVendorInfo() {
    localStorage.setItem("AppVendor", JSON.stringify(this._config.vendor));
    store.commit("CommitVendorStore");
    // Initializing vLive Analytics SDK
    this.initvLiveWebSdk();
    // Defined in Vendor.js Store Module
    // store.dispatch('actGetVendorInfo').then(response => {
    //   if (!response.error) {
    //     // Set the vendor config data to local storage
    //     localStorage.setItem('AppVendor', JSON.stringify(response));
    //     store.commit('CommitVendorStore');

    //     // Initializing vLive Analytics SDK
    //     this.initvLiveWebSdk();
    //   }
    // }).catch(error => {
    //   EventBus.$emit('configError',error)
    //   console.log('[App] getVendorInfo error', error);
    // });
  }
  fetchCountry() {
    // get country code
    store
      .dispatch("actLocate")
      .then((response) => {
        if (response.success) {
          // console.log("actLocate", response);
          let country = response.success;
          localStorage.setItem("country", JSON.stringify(country));
          // Commit Country
          store.commit("commitCountry", country);
        }
      })
      .catch((error) => {
        EventBus.$emit("signupError", error);
      });
  }
  initvLiveWebSdk() {
    // Check for value in vendorid & vendorkey
    if (!(this._vendorid && this._vendorkey)) return;

    import(/* webpackChunkName: 'vLiveWebSdk' */ "vLiveWebSdk/vLiveWebSdkBase").then(
      (VLiveBaseSdk) => {
        let vLiveWebSdk = new VLiveBaseSdk(this._vendorid, this._vendorkey);

        // Set the analytics SDK Object to global window object
        window.vLiveWebSdk = vLiveWebSdk;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/module/config-class.js